import React from 'react';

import { StyledLabel, StyledInput, StyledInputFacade } from './styles';

export const BasicCheckbox = React.forwardRef(
  (
    {
      error,
      disabled,
      checked,
      indeterminate,
      onChange,
      value,
      label,
      children,
      size,
      underline,
      isGroupItem,
      id,
      ...others
    },
    ref
  ) => {
    return (
      <StyledLabel size={size} {...others}>
        <StyledInput
          type="checkbox"
          error={error}
          disabled={disabled}
          checked={checked}
          onChange={onChange}
          value={value}
        />
        <StyledInputFacade
          size={size}
          error={error}
          disabled={disabled}
          checked={checked}
          indeterminate={indeterminate}
        />
      </StyledLabel>
    );
  }
);
